import { Injectable } from '@angular/core';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { TypeNatureMarcheLot } from '../../models/TypeNatureMarcheLot';

@Injectable({
  providedIn: 'root'
})
export class NatureMarcheService {

  constructor() {
  }

  getNatureMarche(controls: any) {
    const natureMarche = new TypeNatureMarcheLot();
    natureMarche.fournitures = controls.get('_SepSep_Initial_SepSep_TypeNatureMarcheLot_SepAtt_fournitures') ? RadioCheckBoxEnum.emptyValue : null;
    natureMarche.services = controls.get('_SepSep_Initial_SepSep_TypeNatureMarcheLot_SepAtt_services') ? RadioCheckBoxEnum.emptyValue : null;
    natureMarche.travaux = controls.get('_SepSep_Initial_SepSep_TypeNatureMarcheLot_SepAtt_travaux') ? RadioCheckBoxEnum.emptyValue : null;
    return natureMarche;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
